const CNAPS_STUDENT = `cnaps-test/v2/`;

export const endpoints = {
  SCHEDULED_EXAMS: `${CNAPS_STUDENT}scheduled/list`,
};

export const examTypes = {};
